<template>
	<div class="bg-white flex flex-col min-h-screen">
		<MobileNav class="md:hidden" />
		<Nav class="hidden md:block" />
		<div class="flex-grow">
			<router-view/>
		</div>
		<div class="border-t m-auto p-6 w-5/6">
			<div class="flex flex-col w-full">
				<div class="flex justify-left space-x-4 w-full">
					<span class="font-bold p-2">MVM Logistics</span>
					<router-link
						class="hover:bg-red-800 hover:text-white p-2 rounded-md"
						to="/terms"
					>
						Terms and Conditions
					</router-link>
					<router-link
						class="hover:bg-red-800 hover:text-white p-2 rounded-md"
						to="/contact"
					>
						Contact
					</router-link>
				</div>
				<div class="p-2">
					<span class="font-thin text-gray-700 text-sm">Copyright © <i class="fa fa-emblem"></i> MVM Logistics Ltd - All rights reserved</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Nav from '@/components/Nav.vue'
import MobileNav from '@/components/MobileNav.vue'

export default {
	name: 'App',
	components: {
		Nav,
		MobileNav,
	},
}
</script>

<style>
#app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}
</style>
